import { format } from 'date-fns';

export const formatDate = (date: Date | number, dateFormat: string) => {
  let result;
  try {
    result = format(date, dateFormat);
  } catch {
    result = undefined;
  }
  return result;
};

export const getTimeStringFromSeconds = (sec: number) => {
  const min = Math.floor(sec / 60);
  const seconds = Math.floor(sec - min * 60);
  return `${min < 10 ? 0 : ''}${min}:${seconds < 10 ? 0 : ''}${seconds}`;
};
